<div mat-dialog-content>
  <p class="font-20">{{ data }}</p>
</div>
<mat-dialog-actions align="center">
  <button
    mat-raised-button
    color="primary"
    class="mat-button-medium"
    [mat-dialog-close]="true"
    cdkFocusInitial
  >
    Ok
  </button>
</mat-dialog-actions>
